<template lang="pug">
  .room-csv-table-component
    // テーブル
    b-table(
      :items="_value"
      :fields="fields"
      :busy="isLoading"
      sticky-header
      no-border-collapse
      table-class="basic-table"
      show-empty
    )
      // ローディング
      template(#table-busy)
        .text-center.table-loading-message
          b-spinner.spinner
          span.message.align-self-center 読込み中...
      // レコード無し
      template(#empty)
        .empty-message
          span 情報がありません

      // ヘッダー：利用者グループ
      template(#head(residentGroupName)="data")
        .d-flex.flex-column
          span 利用者グループ
          span group_name
      // ヘッダー：部屋名
      template(#head(name)="data")
        .d-flex.flex-column
          span 部屋名
          span name
      // ヘッダー：部屋用途
      template(#head(useType)="data")
        .d-flex.flex-column
          span 部屋用途
          span use_type
      // ヘッダー：部屋種別
      template(#head(roomType)="data")
        .d-flex.flex-column
          span 部屋種別
          span room_type
      // ヘッダー：部屋定員 
      template(#head(capacity)="data")
        .d-flex.flex-column
          span 部屋定員
          span capacity

      // セル：部屋名
      template(#cell(name)="row")
        span(v-if="row.item.name != undefined") {{ row.item.name }}
        span.error-message(v-else) エラー
      // セル：用途
      template(#cell(useType)="row")
        span(v-if="row.item.useType != undefined") {{ row.item.useTypeName }}
        span.error-message(v-else) エラー
      // セル：部屋種別
      template(#cell(roomType)="row")
        span(v-if="row.item.roomType != undefined") {{ row.item.roomTypeName }}
        span.error-message(v-else) エラー
      // セル：人数
      template(#cell(capacity)="row")
        template(v-if="row.item.capacity != undefined")
          template(v-if="row.item.roomType != 3 && row.item.roomType != 4")
            span －
          template(v-else)
            span {{ row.item.capacity }}
        template(v-else)
          span.error-message エラー
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { UseType, RoomType } from "@/commons/services/Rooms";

/**
 * ### 部屋CSVテーブルコンポーネント
 */
@Component({})
export default class RoomCsvTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<RoomCsvTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<RoomCsvTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<RoomCsvTableItem> {
    return this.value;
  }
}

/** テーブルの列名の情報 */
export interface RoomCsvTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface RoomCsvTableItem {
  rowNo?: number;
  name?: string;
  useType?: UseType;
  useTypeName?: string;
  roomType?: RoomType;
  roomTypeName?: string;
  capacity?: number | null;
  residentGroupId?: number | null;
  residentGroupName?: string;
}
</script>
